export const MARKDOWN_SELECTOR = "[data-id='Markdown']"
